export default __webpack_public_path__ + "static/media/Marutheswar@2x.72fbfaf2.png";